import { createSlice } from '@reduxjs/toolkit';
import { AliquotLocationListState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { aliquotLocationListThunk } from './thunks';

// Initial State
const initialState: AliquotLocationListState = {
  errors: null,
  status: StoreStatus.IDLE,
  values: null,
  response: null,
};

// Slice
export const aliquotLocationListSlice = createSlice({
  name: 'aliquotLocationList',
  initialState,
  reducers: {
    setValues: (state, action) => ({
      ...state,
      values: action.payload,
    }),
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(aliquotLocationListThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(aliquotLocationListThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(aliquotLocationListThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset, setValues } = aliquotLocationListSlice.actions;
export * from './thunks';
export * from './selectors';
export default aliquotLocationListSlice.reducer;
